import './style.scss';
import { Grid, Box, Typography } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import { useLoadingContext } from '../../contexts/LoadingContext';
import { useEffect, useState } from 'react';
import Route from '../../router';
import NavBarLinks from '../../data/NavBar';
import LanguagesDialog from './LanguagesDialog';
import { useLanguageContext } from '../../contexts/LanguageContext';
import { history } from '../../router/history';
import DocumentHelper from '../../helpers/DocumentHelper';
import ProductCategory from './Content/Products/ProductCategory';
import ProductDetails from './Content/Products/ProductDetails';
import ServiceDetails from './Content/Services/ServiceDetails';
import CampaignEquipotel2025 from '../CampaignEquipotel2025';
import BannerBackdrop from './BannerBackdrop';


const Website = () => {
    const { hideLoading } = useLoadingContext();
    const { translate, currentLanguage } = useLanguageContext();

    const [languageDialogOpen, setLanguageDialogOpen] = useState(false);


    useEffect(() => {
        hideLoading();
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        const link = NavBarLinks.find(n => n.path === history.location.pathname);
        if (link !== undefined) {
            DocumentHelper.setDocumentTitle(translate(link.name))
        }
        // eslint-disable-next-line
    }, [history.location.pathname, currentLanguage]);


    // const path = history.location.pathname;

    // if (path === '/equipotel-2025') {
    //     return <CampaignEquipotel2025 />;
    // }

    return (
        <>
            <Grid container component='main' className='container-website'>
                <Header />

                <Grid container className='grid-content-website' id='website-content'>
                    {
                        NavBarLinks.filter(link => link.internal).map((link, index) => {
                            return <Route component={link.component} path={link.path} exact={true} key={index} />;
                        })
                    }

                    {/* Internal routes */}
                    <Route component={ProductCategory} path='/products/:category' exact={true} />
                    <Route component={ProductDetails} path='/products/:category/:id' exact={true} />
                    <Route component={ServiceDetails} path='/services/:id' exact={true} />

                    <Footer />
                </Grid>

                <Box className='trigger-changelanguage' onClick={() => setLanguageDialogOpen(true)}>
                    <img src={currentLanguage.icon} alt={currentLanguage.initials} className='trigger-changelanguage-icon' />
                    <Typography className='trigger-changelanguage-name'>{currentLanguage.initials}</Typography>
                </Box>
            </Grid>

            {/* <BannerBackdrop /> */}

            <LanguagesDialog 
                isOpen={languageDialogOpen} 
                setClosedDialog={() => setLanguageDialogOpen(false)} 
            />
        </>
    );
}


export default Website;